module.exports = __webpack_public_path__ + "static/sjopenna_2k-b3e36049403d6e2ac3284eb120ecc99a.jpg";